import { when } from "./functions";

export const getExtension = (filename: string): string | undefined => {
  const index = filename.lastIndexOf(".");
  return index > 0 ? filename.substring(index + 1).toLowerCase() : undefined;
};

export const isExtensionPdf = (filename: string) => getExtension(filename) === "pdf";

export const isExtensionImage = (filename: string) =>
  when(getExtension(filename), (ext) => ["jpg", "jpeg", "gif", "png"].includes(ext));

export const isExtensionJson = (filename: string) => getExtension(filename) === "json";
